/**
 * @file The caller's own runs, newest scheduled first, at most `limit`.
 * Consumers: `AnalyticsMyRunsTable` over the `runs` collection group and
 * `analyticsReportArchiveQuery` over one report's `runs`. A caller who cannot
 * read Org also filters out Org runs, because the rules refuse a list that
 * could return one; each lane has its own composite index, at collection-group
 * and at collection scope, in `firestore.indexes.json`.
 */
import { ANALYTICS_SCOPE_LEVELS } from '#types';

import type { QueryOptions } from '@/store';

export const analyticsMyRunsQuery = (
  uid: string,
  canReadOrg: boolean,
  limit: number,
): QueryOptions => ({
  orderBy: { field: 'scheduledAt', direction: 'desc' },
  extraConstraints: [
    { type: 'where', field: 'recipientUid', op: '==', value: uid },
    ...(canReadOrg
      ? []
      : [
          {
            type: 'where',
            field: 'level',
            op: 'in',
            value: ANALYTICS_SCOPE_LEVELS.filter((level) => level !== 'org'),
          } satisfies NonNullable<QueryOptions['extraConstraints']>[number],
        ]),
    { type: 'limit', n: limit },
  ],
});
